"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const QuestionMark = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _react.default.createElement("path", {
  d: "M0 8c0-4.411 3.589-8 8-8s8 3.589 8 8c0 4.412-3.589 8-8 8s-8-3.588-8-8zm8.75 2v-.876C10.042 8.777 11 7.558 11 6.111 11 4.395 9.655 3 8 3 6.346 3 5 4.395 5 6.111h1.5c0-.859.673-1.555 1.5-1.555s1.5.696 1.5 1.555c0 .858-.673 1.556-1.5 1.556h-.75V10h1.5zM9 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0z",
  className: "fill",
  fillRule: "evenodd"
}));

var _default = QuestionMark;
exports.default = _default;